// ✅ File: cart-item-qty.js (Rewritten to fix plus/minus and stabilize event listeners)

(async () => {
  const { Core } = await importModule('Core');

  const EL_PARENT = '[data-cart-item]';
  const CN_LOADING = '!loading';
  const ATTR_VARIANT_ID = 'variant-id';
  const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
  const ATTR_LINE_KEY = 'line';
  const ATTR_ITEM_KEY = 'key';

  class CartControl extends Core {
    get variantId() {
      return this.getAttribute(ATTR_VARIANT_ID);
    }

    get sellingPlanId() {
      return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
    }

    get $parentItem() {
      return this.closest(EL_PARENT);
    }

    get line() {
      return this.getAttribute(ATTR_LINE_KEY);
    }

    get key() {
      return this.getAttribute(ATTR_ITEM_KEY);
    }

    parentLoading() {
      this.$parentItem?.classList.add(CN_LOADING);
    }
  }

  customElements.define('cart-qty-button', class extends CartControl {
    connectedCallback() {
      this.addEventListener('click', this._onQtyChange.bind(this));
    }

    _onQtyChange(e) {
      e.preventDefault();
      this.parentLoading();

      const newQty = parseInt(this.getAttribute('set-value'), 10);
      if (isNaN(newQty)) return;

      this.publish('cart:change', {
        id: this.variantId,
        key: this.key,
        quantity: newQty,
        selling_plan: this.sellingPlanId,
        line: this.line,
        src: this.tagName
      });
    }
  });

  customElements.define('cart-qty-input', class extends CartControl {
    connectedCallback() {
      this.addEventListener('change', this._onQtyChange.bind(this));
    }

    _onQtyChange(e) {
      const value = parseInt(e.target.value, 10);
      if (isNaN(value)) return;

      this.parentLoading();

      this.publish('cart:change', {
        id: this.variantId,
        key: this.key,
        quantity: value,
        selling_plan: this.sellingPlanId,
        line: this.line,
        src: this.tagName
      });
    }
  });
})();
